import { createModalProvider } from "~components/shared/ModalContext/ModalContext";
import { ConfirmDialog } from "./ConfirmDialog";

export const { provider: ConfirmDialogProvider, hook: useConfirmDialog } =
  createModalProvider(ConfirmDialog);
